import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import moment from "moment";

import {LeadFilterDataAPI, CallerAPI, BulkLeadAssignCallerAPI} from "./../../../API/Team/LeadAPI";
//import Sidebar from "./../Common/Sidebar";
//import Header from "./../Common/Header";
//import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
//import { data } from "jquery";
import { ToastContainer } from 'react-toastify';
import { errorMesg } from "../../Toaster";
import ReactSelect from 'react-select';
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";
import "./../../../Public/css/leads_list.css";


const LeadFilter = () =>{

    const {filtertype} = useParams();
    const [searchParam] = useSearchParams();

    const [leads, setLeads] = useState([]);
    //const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [btnloader, setBtnLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [callers, setCallers] = useState([]);
    const [callername, setCallerName] = useState("");
    const [leadids, setLeadIDs] = useState([]);
    const [isleadassign, setIsLeadAssign] = useState(false);
    const [programs, setPrograms] = useState([]);
    const [institute, setInstitute] = useState([]);
    const [selectedcallervalues, setSelectedCallerValues] = useState([]);
    const [selectedcaller, setSelectedCaller] = useState([]);
    const [filterprogram, setFilterProgram] = useState("");
    const [filterinstitute, setFilterInstitute] = useState("");

    const perpagedata = 20;

    const filterparams = new URLSearchParams();
    

    useEffect(() => {

        CallerAPI(setCallers);
    }, []);

    useEffect(() => {

        console.log('search params====' + searchParam);        

        if(searchParam !== "" && searchParam !== null)
        {
            if(searchParam.get('filter_campaignid') !== "" && searchParam.get('filter_campaignid') !== null)
            {
                filterparams.append('filter_campaignid', searchParam.get('filter_campaignid'));
            }

            if(searchParam.get('filter_callerid') !== "" && searchParam.get('filter_callerid') !== null)
            {
                filterparams.append('filter_callerid', searchParam.get('filter_callerid'));
            }

            if(searchParam.get('filter_startdate') !== "" && searchParam.get('filter_startdate') !== null)
            {
                filterparams.append('filter_startdate', searchParam.get('filter_startdate'));
            }

            if(searchParam.get('filter_enddate') !== "" && searchParam.get('filter_enddate') !== null)
            {
                filterparams.append('filter_enddate', searchParam.get('filter_enddate'));
            }

            if(searchParam.get('filterprogram') !== "" && searchParam.get('filterprogram') !== null)
            {
                filterparams.append('filterprogram', searchParam.get('filterprogram'));
            }

            if(searchParam.get('filterinstitute') !== "" && searchParam.get('filterinstitute') !== null)
            {
                filterparams.append('filterinstitute', searchParam.get('filterinstitute'));
            }

            if(currentPage)
            {
                filterparams.append('page', currentPage);
            }

            if(perpagedata)
            {
                filterparams.append('per_page', perpagedata);
            }
        }

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, setIsLeadAssign, filterparams, setInstitute, setPrograms);

        CallerAPI(setCallers);
        
        setLeadIDs([]);

    }, [currentPage, isleadassign]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        //setIsFilterPagination(true);

        //handleFilterLeads();
    }

    const handleCallerName = (selcaller) =>{
        console.log('>>>' + JSON.stringify(selcaller));
        
        if(selcaller)
        {
            let callervalue = selcaller.map(datalist => datalist.value);
            setSelectedCallerValues(callervalue);

            setSelectedCaller(selcaller);
        }
    }

    const handleLeadAssign = (e) =>{
        
        console.log('selected caller======' + JSON.stringify(selectedcaller));
        console.log('selected caller======' + selectedcaller.length);        

        //let assignedcaller = [];

        if(selectedcaller)
        {
            let callerdata = selectedcaller.map(callerlist => callerlist.value);

            //let assignedcaller = callerdata.split(",");

            //console.log('Assigned caller=====' + assignedcaller);
            //console.log('Assigned caller=====' + typeof assignedcaller);

            if(leadids.length > 0)
            {
                console.log('caller id===' + callerdata);    
                console.log('selected ids===' + leadids);    

                const params = {
                                'callerid': callerdata,
                                'leadids': leadids
                            };
                            
                BulkLeadAssignCallerAPI(params, setIsLeadAssign, setFilterProgram, setFilterInstitute, setSelectedCaller);
            }
            else
            {
                errorMesg('Please select a lead to assign this caller');
                return;    
            }
        }
        else
        {
            errorMesg('Please select a caller');
            return;
        }

        /*if(callername !== "" && callername !== null && callername !== undefined)
        {
            if(leadids.length > 0)
            {
                console.log('caller id===' + callername);    
                console.log('selected ids===' + leadids);    

                const params = {
                                'callerid': callername,
                                'leadids': leadids
                            };
                            
                BulkLeadAssignCallerAPI(params, setIsLeadAssign);
            }
            else
            {
                errorMesg('Please select a lead to assign this caller');
                return;    
            }
        }
        else
        {
            errorMesg('Please select a caller');
            return;
        }*/
    }

    const handleSelectLead = (lid) =>{
        if(leadids.includes(lid))
        {
            setLeadIDs(leadids.filter(item => item !== lid));
        }
        else
        {
            setLeadIDs([...leadids, lid]);
        }
    }

    const handleSelectAllLeads = () =>{

        if(leadids.length === leads.length)
        {
            setLeadIDs([]);
        }
        else
        {
            setLeadIDs(leads.map(item => item.id));
        }
    }

    const handleProgram = (e) =>{
        setFilterProgram(e.target.value);
    }

    const handleInstitute = (e) =>{

        setFilterInstitute(e.target.value);
    }

    const handleLeadFilter = () =>{

        const filterparams = new URLSearchParams();
        
        if(filterprogram)
        {
            filterparams.append('filterprogram', filterprogram);
        }

        if(filterinstitute)
        {
            filterparams.append('filterinstitute', filterinstitute);
        }

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, setIsLeadAssign, filterparams, setInstitute, setPrograms);
    }


    return(
    <Layout>
        <div className="content">
            <div className="row">
                <div className="col-md-12">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-12">
                                {filtertype === 'freshlead' ?
                                    <h4 className="page-title">Fresh Leads</h4>
                                :
                                    (filtertype === 'warmleads' ?
                                        <h4 className="page-title">Warm Leads</h4>
                                    :
                                        (filtertype === 'contactedleads' ?
                                            <h4 className="page-title">Contacted Leads</h4>
                                        :
                                            (filtertype === 'deadleads' ?
                                                <h4 className="page-title">Dead Leads</h4>
                                            :
                                                (filtertype === 'coldleads' ?
                                                    <h4 className="page-title">Cold Leads</h4>
                                                :
                                                    (filtertype === 'attemptleads' ?
                                                        <h4 className="page-title">Attempt to Contact Leads</h4>
                                                    :
                                                        (filtertype === 'enrolledleads' ?
                                                            <h4 className="page-title">Enrolled Leads</h4>
                                                        :
                                                            (filtertype === 'totalleads' ?
                                                                <h4 className="page-title">Total Leads</h4>
                                                            :
                                                                <></>
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card crm-leads-filter-card">
                        <div className="card-body">
                            <div className="row crm-filter-row-top">
                                {/*<div className="col-md-7">*/}
                                    <div className="col-md-2 mb-3">
                                        <label class="crm-filter-label">Program</label>
                                        <select className="form-select me-2" name="program" value={filterprogram} onChange={handleProgram }>

                                            <option value="">Select Program</option>
                                            {programs.map((programlist) =>
                                                (
                                                    <option key={programlist} value={programlist}>{programlist}</option>

                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <label class="crm-filter-label">Institute</label>
                                        <select className="form-select me-2" name="institute" value={filterinstitute} onChange={handleInstitute }>
                                            <option value="">Select Institute</option>
                                            {institute.map((institutelist) =>
                                                (
                                                    <option key={institutelist} value={institutelist}>{institutelist}</option>

                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className="col-md-2 mb-3">
                                        <label class="crm-filter-label opacity-0">Actions</label>
                                        <div class="crm-filter-actions">
                                            <button type="button" className="btn btn-primary"  onClick={handleLeadFilter}>
                                                {btnloader ?
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                :
                                                    <p>Filter Leads</p>
                                                }
                                            </button>
                                        </div>
                                    </div>
                                {/*</div>*/}

                                {/*<div className="col-md-5">*/}
                                    <div className="col-md-3 mb-3">
                                        <label class="crm-filter-label opacity-0">Caller</label>
                                        <ReactSelect className="me-2" value={selectedcaller} onChange={handleCallerName} options={callers} menuPosition="fixed"
  classNamePrefix="crm-select" isMulti></ReactSelect>

                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label class="crm-filter-label opacity-0">Actions</label>
                                        <div class="crm-filter-actions">
                                            <button type="button" className="btn btn-primary"  onClick={handleLeadAssign}>
                                                {btnloader ?
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                :
                                                    <p>Assign Lead</p>
                                                }
                                            </button>
                                        </div>
                                    </div>
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">

                            <div className="table-responsive table-wrapper">

                                {loading ?
                                    <div>
                                        <ContentLoader />
                                    </div>
                                :

                                <table className="table table-data-section" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="checkbox" id="flexCheckDefault" checked={leadids.length > 0 && leadids.length === leads.length} onChange={handleSelectAllLeads} />
                                                    <label class="form-check-label" for="flexCheckDefault"></label>
                                                </div>
                                            </th>

                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Contact</th>
                                            <th>Location</th>
                                            <th>Program</th>
                                            <th>Institute</th>
                                            {filtertype === 'freshlead' ?
                                            <th>Caller Name</th>
                                            :
                                            <th>Lead Status</th>
                                            }
                                            <th>Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>


                                        {
                                        leads && leads.length > 0  ?
                                            leads.map(lead =>
                                                (

                                                    <tr key={lead.id}>
                                                        <td>
                                                            <div class="form-check form-check-inline">
                                                                <input class="form-check-input" type="checkbox" id={'chkleaddata'+lead.id} checked={leadids.includes(lead.id)} onChange={() => handleSelectLead(lead.id)} />
                                                                <label class="form-check-label" for={'chkleaddata'+lead.id}></label>
                                                            </div>

                                                            {/*<Link to={`/team/lead-profile/${lead.id}`} className="">
                                                                <i className="fa fa-pencil"></i>
                                                            </Link>*/}
                                                        </td>


                                                        <td>
                                                            <Link to={`/team/lead-profile/${lead.id}`} class="txt-lead-name">
                                                                {lead.name}
                                                            </Link>
                                                        </td>
                                                        <td>{lead.email}</td>
                                                        <td>{lead.contact}</td>
                                                        <td>{lead.location}</td>
                                                        <td>{lead.program}</td>
                                                        <td>{lead.institute}</td>

                                                        {filtertype === 'freshlead' ?
                                                        <td>{lead.callername}</td>
                                                        :
                                                        <td>
                                                            {lead.stagename !== "" && lead.stagename !== null ?
                                                            <span class="badge badge-tag badge-purple-light">{lead.stagename}</span>
                                                            :
                                                                (lead.subdispositionname !== "" && lead.subdispositionname !== null ?
                                                                <span class="badge badge-tag badge-purple-light">{lead.subdispositionname}</span>
                                                                :
                                                                    (lead.dispositionname !== "" && lead.dispositionname !== null && lead.dispositionname !== null ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.dispositionname}</span>
                                                                    :
                                                                    <></>
                                                                    )
                                                                )
                                                            }
                                                        </td>
                                                        }
                                                        <td>{moment(lead.created_at).format('DD-MM-YYYY h:mm')} </td>

                                                    </tr>
                                                )
                                            )
                                        :
                                            <tr>
                                                <td colspan="9">
                                                    <center>No records found</center>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                }

                            </div>
                        </div>
                    </div>

                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>

        </div>
    </Layout>
    )
}

export default LeadFilter;
